<template>
  <div>
    <div class="vx-row mb-6">
      <h3>{{ isLeader ? "Leader Candidates" : "Member Candidates" }}</h3>
    </div>
    <vs-table
      search
      stripe
      border
      description
      :sst="true"
      :data="table.data"
      :max-items="table.length"
      :total="table.total"
      @change-page="handleChangePage"
      @search="handleSearch"
      @sort="handleSort"
    >
      <template slot="header">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ this.table.start }} - {{ this.table.end }} 
              {{ this.table.search == "" ? ' of ' + this.table.total : ' of ' + this.table.totalSearch + ' (filtered from ' + this.table.total + ' total entries)' }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item
              v-for="item in table.limits"
              :key="item"
              @click="handleChangelength(item)"
            >
              <span>{{ item }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </template>
      <template slot="thead">
        <vs-th>Action</vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="work_id_number">Work ID Number</vs-th>
        <vs-th sort-key="email">Email</vs-th>
        <vs-th sort-key="code_external">External Code</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <div class="vx-input-group flex">
                <feather-icon
                  title="Add"
                  icon="PlusIcon"
                  svgClasses="w-5 h-5 text-success stroke-current"
                  class="ml-2"
                  @click.stop="getThisCandidate(indextr)"
                />
              <!-- <vs-button
                @click.stop="getThisCandidate(indextr)"
                size="small"
                color="success"
                icon-pack="feather"
                icon="icon-check"
                title="Edit"
                style="margin-right: 5px"
              />               -->
            </div>
          </vs-td>
          <vs-td :data="data[indextr].name">
            {{ data[indextr].name }}
          </vs-td>
          <vs-td :data="data[indextr].work_id_number">
            {{ data[indextr].work_id_number }}
          </vs-td>
          <vs-td :data="data[indextr].email">
            {{ data[indextr].email }}
          </vs-td>
          <vs-td :data="data[indextr].external_code">
            {{ data[indextr].external_code }}
          </vs-td>          
        </vs-tr>
      </template>
    </vs-table>
    <vs-pagination
      style="padding-top: 5px"
      :total="table.totalPage"
      v-model="setPage"
    />
  </div>
</template>
<script>
import internal from "stream";
import moment from "moment";

export default {
  components: {},
  props: {
    baseUrl: {
      type: String,
    },
    isLeader: {
      type: Boolean,
    }
  },
  data() {
    return {
      deleteId: null,
      table: this.tableDefaultState(),
      itemDel: 0,
    };
  },
  methods: {
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      };
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.handleChangePage(1)
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    handleClose() {
      this.getData();
      this.$emit("close");
    },
    handleCreate() {
      this.customerId = null;
      this.detail = false;
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get(this.baseUrl + "/candidates", {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.data = resp.data.records;
            this.setStartEnd();
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    setStartEnd() {
      let valStart = this.table.length * this.table.page - this.table.length + 1;

      if (this.table.total == 0 && this.table.totalSearch == 0) {
        valStart = 0;
      }

      if (this.table.total > 0 && this.table.totalSearch == 0 && this.table.search != "") {
        valStart = 0;
      }
      
      let valEnd = this.table.length * this.table.page;

      if ( this.table.search != "" && this.table.totalSearch < this.table.length) {
        valEnd = this.table.totalSearch;
      }else{
        valEnd = this.table.length;
      }

      this.table.start = valStart;
      this.table.end = valEnd;   
    },
    getThisCandidate(i){
      this.$emit("addToListDT", this.table.data[i]);
    }
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD MMM YYYY,hh:mm:ss");
      }
    },
  },
  watch: {
    flag() {
      this.getData();
    },
    isLeader: function () {
      this.getData();
    }
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
};
</script>
